import { expecting } from "./expecting";
import { newborn } from "./newborn";
import { infant } from "./infant";
import { toddler } from "./toddler";

export const GUIDES = {
  expecting,
  "0-3": newborn,
  "4-11": infant,
  "2-4": toddler,
};

export const AGE_TO_GUIDE = {
  expecting: "expecting",
  "0-3": "0-3",
  "4-11": "4-11",
  "12-23": "2-4",
  "2-4": "2-4",
  "5-plus": "2-4",
};
